export default "__VITE_ASSET__5de56a24__"